// extracted by mini-css-extract-plugin
module.exports = {"divider":"VerticalScrollDivider_divider__1qaTY","left":"VerticalScrollDivider_left__3n0Nh","right":"VerticalScrollDivider_right__3LiQO"};